import {useEffect, useState} from 'react';
import {useHistory} from "react-router-dom";

const useActivePage = () => {
    const history = useHistory();
    let activeUrlPage = new URLSearchParams(window.location.search).get("page");
    const [pageNumber, setPageNumber] = useState(activeUrlPage ? Number(activeUrlPage) : 1);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [scrollOnChange, setScrollOnChange] = useState(true);

    useEffect(() => {
        if (activeUrlPage && (+activeUrlPage < 1 || isNaN(+activeUrlPage))) {
            return history.push('/404')
        }
    }, [history, activeUrlPage])

    useEffect(() => {
        setPageLoaded(false);
        if (scrollOnChange) {
            window.scrollTo(0, 0);
        }
        setPageLoaded(true);
        return () => setPageLoaded(false);
    }, [pageNumber, scrollOnChange])

    return {pageNumber, pageLoaded, setPageNumber, setScrollOnChange};
};

export default useActivePage;
